import axios from '../axios';

//加载头文件
//import * as QcMaterialQualityApi from './moudules/qc/QcMaterialQualityApi'; //材料质检单
//  QcMaterialQualityApi,//材料质检单

// 材料质检单列表
export const getQcMaterialQualityPage = data => {
return axios({
url: '/api/sys/qc/getQcMaterialQualityPage',
method: 'post',
data
})
};
// 材料质检单总合计
export const getQcMaterialQualitySum = data => {
  return axios({
  url: '/api/sys/qc/getQcMaterialQualitySum',
  method: 'post',
  data
  })
};
// 材料质检单保存
export const saveQcMaterialQuality = data => {
  if (data.billId) {
    return axios({
      url: '/api/sys/qc/updateQcMaterialQuality',
      method: 'post',
      data
      })
  }else{
    return axios({
      url: '/api/sys/qc/saveQcMaterialQuality',
      method: 'post',
      data
      })
  }
};

// 材料质检单修改
export const updateQcMaterialQuality = data => {
return axios({
url: '/api/sys/qc/updateQcMaterialQuality',
method: 'post',
data
})
};

// 材料质检单删除
export const deleteQcMaterialQualitys = data => {
return axios({
url: '/api/sys/qc/deleteQcMaterialQualitys',
method: 'post',
data
})
};

// 材料质检单审核 auditStatus 1已审核 0未审核/反
export const auditQcMaterialQualitys = data => {
  return axios({
    url: '/api/sys/qc/auditQcMaterialQualitys',
    method: 'post',
    data
  })
};

// 材料质检单作废 cancelStatus 1已作废 0未作废
export const cancelQcMaterialQualitys = data => {
  return axios({
    url: '/api/sys/qc/cancelQcMaterialQualitys',
    method: 'post',
    data
  })
};

// 材料质检单查单条
export const getQcMaterialQuality = data => {
return axios({
url: '/api/sys/qc/getQcMaterialQuality',
method: 'post',
data
})
};
// 材料质检明细列表
export const getQcMaterialQualityEntryPage = data => {
  return axios({
  url: '/api/sys/qc/getQcMaterialQualityEntryPage',
  method: 'post',
  data
  })
  };
  
  // 材料质检明细保存
  export const saveQcMaterialQualityEntry = data => {
  return axios({
  url: '/api/sys/qc/saveQcMaterialQualityEntry',
  method: 'post',
  data
  })
  };
  
  // 材料质检明细修改
  export const updateQcMaterialQualityEntry = data => {
  return axios({
  url: '/api/sys/qc/updateQcMaterialQualityEntry',
  method: 'post',
  data
  })
  };
  
  // 材料质检明细删除
  export const deleteQcMaterialQualityEntrys = data => {
  return axios({
  url: '/api/sys/qc/deleteQcMaterialQualityEntrys',
  method: 'post',
  data
  })
  };
  
  // 材料质检明细查单条
  export const getQcMaterialQualityEntry = data => {
  return axios({
  url: '/api/sys/qc/getQcMaterialQualityEntry',
  method: 'post',
  data
  })
  };



// WEBPACK FOOTER //
// ./src/api/moudules/QcMaterialQualityi.js